<template>
  <section class="card">
    <h2 class="section-heading">
      {{ t('signature.title') }}
    </h2>

    <div class="form-grid">
      <div class="mt-3 signature-box grid-span-2">
        <SignaturePad
          v-model="form.sign"
          :title="t('signature.please_sign_here')"
          class="signature-pad"
        />
        <p class="error-text" v-if="formErrors.has('signature.sign')">
          {{ t(formErrors.first('signature.sign')) }}
        </p>
      </div>

      <!-- Name -->

      <!-- Passport -->

      <!-- Date -->
      <div class="mt-3">
        <label class="question-label">{{ t('signature.date') }}</label>
        <div class="form_group">
          <input
            type="date"
            v-model="form.date"
            @input="clearError('signature.date')"
            readonly
            class="disabled-input"
          />
        </div>
        <p class="error-text" v-if="formErrors.has('signature.date')">
          {{ t(formErrors.first('signature.date')) }}
        </p>
      </div>
    </div>
  </section>
</template>

<script setup>
import { watch } from 'vue'
import { useI18n } from 'vue-i18n'
import SignaturePad from '@/components/SignaturePad.vue'
import { reactive } from 'vue'
import Error from '@/utils/Error'

const { t } = useI18n()

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  formErrors:{
    type:Object,
    required:false,
    default:reactive(new Error({}))
  }
})

const emit = defineEmits(['update:modelValue'])
const today = new Date().toISOString().split('T')[0];
const form = reactive({
  sign: '',
  date: today,
  ...props.modelValue
});

const clearError = async(name)=>{
	emit("removeError",name)
}

watch(
  form,
  (newVal) => {
    emit("update:modelValue", newVal);
    if (newVal?.sign) {
      clearError('signature.sign');
    }
  },
  { deep: true }
);
watch(()=>props.modelValue,
(newVal) =>{
  Object.assign(form,{...newVal})
},{deep:true,immediate:true})

</script>
<style scoped>
  .signature-row {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  flex-wrap: wrap;
}

.signature-col {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 160px;
  flex: 1;
}

.signature-box {
  flex: 2;
  min-width: 260px;
}

.signature-pad {
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
}
.disabled-input {
  background-color: #f3f4f6;
  cursor: not-allowed;
}
</style>
